import React from "react";
import {
  CheckCircle,
  CheckCircleIcon,
  Clock,
  Info,
  XCircle,
  XCircleIcon,
} from "lucide-react";
import {
  convertDecimalToTime,
  formatDate,
  formatTime,
} from "../../utils/utils";

const AttendanceTable = ({ data }) => {
  return (
    <div className="mt-6">
<h2 className="text-2xl font-medium mb-4">Attendance History</h2>
<div className="bg-[#131313] rounded-lg border border-[#333333] overflow-x-auto scrollbar-hide">
  <table className="min-w-full text-sm border-separate border-spacing-0">
    <thead className="bg-[#131313] text-[#F3F3F3]">
      <tr>
        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider border-x border-[#333333] rounded-tl-lg">
          Date
        </th>
        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider border-x border-[#333333]">
          Clock In
        </th>
        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider border-x border-[#333333]">
          Clock Out
        </th>
        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider border-x border-[#333333]">
          Break Time
        </th>
        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider border-x border-[#333333]">
          Total Hours
        </th>
        <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider border-x border-[#333333] rounded-tr-lg">
          Status
        </th>
      </tr>
    </thead>
    <tbody className="bg-[#131313] text-white">
      {data.map((item, index) => {
        const isLast = index === data.length - 1;
        return (
          <tr
            key={index}
            className={`border-b border-[#333333] ${
              isLast ? "rounded-b-lg" : ""
            }`}
          >
            <td className={`px-4 py-4 border-x border-[#333333] ${index === data.length - 1 ? "rounded-bl-lg" : ""}`}>
              {formatDate(item.date)}
            </td>
            <td className="px-4 py-4 text-gray-300 border-x border-[#333333]">
              {formatTime(item.loginTime)}
            </td>
            <td className="px-4 py-4 text-gray-300 border-x border-[#333333]">
              {formatTime(item.logoutTime)}
            </td>
            <td className="px-4 py-4 text-gray-300 border-x border-[#333333]">
              {convertDecimalToTime(item.breakTime)}
            </td>
            <td className="px-4 py-4 text-gray-300 border-x border-[#333333]">
              {convertDecimalToTime(item.regularHours)}
            </td>
            <td
              className={`px-4 py-4 border-x border-[#333333] ${
                isLast ? "rounded-br-lg" : ""
              } ${
                item.status === "Present"
                  ? "text-green-400"
                  : item.status === "Late" || item.status === "Pending"
                  ? "text-yellow-400"
                  : item.status === "Absent"
                  ? "text-red-400"
                  : "text-[#FFCA20]"
              }`}
            >
              <div className="flex items-center gap-2">
                {item.status === "Present" && <span className="text-lg">✔</span>}
                {item.status === "Absent" && <span className="text-lg">✖</span>}
                {item.status === "Pending" && <Clock className="h-4 w-4" />}
                {!["Present", "Absent", "Pending"].includes(item.status) && (
                  <Info className="h-4 w-4" />
                )}
                <span>{item.status}</span>
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>

    </div>
  );
};

export default AttendanceTable;
